import React from 'react'
import { Button } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useHistory } from "react-router-dom";
// import moment from 'moment'
import { getDate } from '../../helpers/TimeDate'



export const SubscriptionHistory = () => {
  const historys = useHistory();
  const data = useSelector((state) =>
state.PlanReducer.planHistory?state.PlanReducer.planHistory
    .map((history, key) => (
      <div class="d-flex justify-content-center" key={key}>
        <div className="card mb-5 w-50 p-3 border current_plan">
          <p className="text-center">Current Plan</p>
          <div className="d-md-flex justify-content-between">
            <div>
              <p>
                <strong>Plan :</strong>
                <small> {history.plan.courseName}  </small>
              </p>
              <p>
                <strong>Number of Days / Week :</strong>
                <small> {history.plan.frequency} </small>
              </p>
            </div>
            <div>
              <p>
                <strong>Start Date :</strong>
                <small> {getDate(history.startDate)} </small>
              </p>
              <p>
                <strong>End Date :</strong>
                <small> {getDate(history.endDate)} </small>
              </p>
            </div>
          </div>
          <div className="d-md-flex justify-content-between">
            <div>
              <p>
                <strong>Total Session :</strong>
                <small> {history.totalSession} </small>
              </p>
            </div>
            <div>
              <p>
                <strong>Available Session :</strong>
                <small> {history.availableSession} </small>
              </p>
            </div>
          </div>

          <div className="d-md-flex justify-content-between">
            <div>
              <p>
                <strong>Total Session this week :</strong>
                <small> {history.totalWeeklySession} </small>
              </p>
            </div>
            <div>
              <p>
                <strong>Available Session this week :</strong>
                <small> {history.availableWeeklySession} </small>
              </p>
            </div>
          </div>
           <div className="planpricing mb-4" style={{ paddingTop: "1rem", }}>
            <div className="container-fluid">
            <div className="d-flex justify-content-center">
                    {/* <button
                      className="button  aligni-item-center"
                      onClick={() =>historys.push({pathname: "/upgradePlan", state: history})}
                      style={{ width: "10rem", }}
                    >
                      Upgrade Plan
                    </button> */}
          </div>
            </div>
          </div>  
          
          
          {/* <div className="d-md-flex justify-content-between"> */}
          <p className="text-danger text-center">
            <i className="fa fa-exclamation-triangle"></i> Your{' '}
            {history.availableWeeklySession} session going to expire at{' '}
            {getDate(history.weekEnd)}
          </p>
          {/* </div> */}
        </div>
      </div>
    )):""
  )

  // const [loder, setLoder] = useState(false)

  return (
    <div>
      <h1 className="text-center text-muted pt-0 mt-md-5 mt-md-4 ">Your Plans History</h1>
      <div>{data}</div>
    </div>
  )
}

export default SubscriptionHistory